import { useContext, useEffect, useState } from 'react'
import { generatePath, useParams } from 'react-router'
import { Box, CircularProgress, Typography } from '@mui/material'
import { BreadcrumbNav } from '../../customComponents/BreadcrumbNav'
import { GetOrganization } from '../../../services/OrganizationService'
import { type OrganizationDetailsModel } from '../../../models/OrganizationDetailsModel'
import { AnnualPlanList } from './AnnualPlanList'
import { AppRoutes } from '../../Routes'
import { SecurityLevel } from '../../../utils/genericTypes'
import { useAuth } from '../../../hooks/use-auth'
import { SetBreadcrumbContext } from '../../../contextProviders/BreadcrumbProvider'
import { handleApiResponse } from '../../../utils/apiHelpers'

export const PlanningInstance = (): JSX.Element => {
  const { rcnId } = useParams()
  const [rcn, setRcn] = useState<OrganizationDetailsModel | null>(null)
  const { user } = useAuth()
  const setBreadcrumbs = useContext(SetBreadcrumbContext)

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      if (rcnId == null) {
        return
      }

      const rcn = await handleApiResponse(GetOrganization(rcnId))
      if (rcn != null) setRcn(rcn)
    }

    if (user == null) return

    if (![SecurityLevel.ProjectAdmin, SecurityLevel.ProjectUser].includes(user.securityLevel)) {
      const homeRoute = generatePath(AppRoutes.HOME)
      setBreadcrumbs([{ name: 'Home', route: homeRoute }])
    }
    void fetchData()
  }, [rcnId])

  if (rcn == null) {
    return <CircularProgress />
  }

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: '12px'
    }}
    >
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '24px'
      }}
      >
        <BreadcrumbNav />
        <Typography variant='h1'>Annual Planning</Typography>
      </Box>

      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '24px'
      }}
      >
        <Typography variant='h4'>{rcn.name}</Typography>
        <AnnualPlanList rcnId={rcn.id} />
      </Box>
    </Box>
  )
}
